/* Page Média (par objectif) : vidéos YouTube lues AU CLIC dans la carte (imagette, puis iframe youtube-nocookie), un seul lecteur actif sur toute la page.
   Maquette : js/media.js. Ici le balisage est rendu par Liquid (sections mi-media-goal) : le lien YouTube de l'imagette fonctionne sans JavaScript, ce module le remplace par le lecteur.
   Aucun script ni requête tiers avant le clic. Coupe l'audio du podcast quand une vidéo démarre, et réciproquement.
   Balisage : <li data-md-card="<id>" data-md-title="…" [data-md-cc]> contenant [data-md-frame] > a[data-md-play]. data-md-cc : active les sous-titres (français automatiques). */
(() => {
  if (window.__miMediaInit) return;
  window.__miMediaInit = true;

  const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const saved = new WeakMap();   // carte -> HTML de l'imagette d'origine
  const lang = () => ((document.documentElement.lang || 'fr').slice(0, 2) === 'fr' ? 'fr' : 'en');
  const embed = (id, cc) => `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&modestbranding=1&playsinline=1&hl=${lang()}${cc ? '&cc_load_policy=1&cc_lang_pref=fr' : ''}`;

  function reset(except) {
    document.querySelectorAll('[data-md-card].is-playing').forEach((card) => {
      if (card === except) return;
      const frame = card.querySelector('[data-md-frame]');
      if (frame && saved.has(card)) frame.innerHTML = saved.get(card);
      card.classList.remove('is-playing');
    });
  }

  function start(card, id) {
    const frame = card.querySelector('[data-md-frame]');
    if (!frame) return;
    if (document.documentElement.classList.contains('design-mode') || document.body.hasAttribute('data-design-mode')) return;
    document.dispatchEvent(new CustomEvent('mi:media-start', { detail: 'youtube' }));
    document.querySelectorAll('audio, video').forEach((m) => { try { m.pause(); } catch (e) { /* lecteur absent */ } });
    reset(card);
    if (!saved.has(card)) saved.set(card, frame.innerHTML);
    frame.innerHTML = `<iframe src="${embed(id, card.hasAttribute('data-md-cc'))}" title="${esc(card.dataset.mdTitle || '')}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>`;
    card.classList.add('is-playing');
    const r = frame.getBoundingClientRect();
    if (r.top < 70 || r.bottom > innerHeight) frame.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    frame.querySelector('iframe')?.focus({ preventScroll: true });
  }

  /* Accueil par BESOIN : puces-onglets (aria-selected, flèches, Début, Fin) ; le panneau actif change en place, le lecteur en cours est remis en imagette. */
  document.querySelectorAll('[data-hm-tabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[role=tab]')];
    const go = (tab, focus) => {
      reset(null);
      tabs.forEach((b) => { const on = b === tab; b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1; if (on && focus) b.focus(); });
      root.querySelectorAll('[role=tabpanel]').forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
    };
    tabs.forEach((b, i) => {
      b.addEventListener('click', () => go(b));
      b.addEventListener('keydown', (e) => {
        const k = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (k == null) return;
        e.preventDefault(); go(tabs[(k + tabs.length) % tabs.length], true);
      });
    });
  });

  document.addEventListener('click', (e) => {
    const p = e.target.closest('[data-md-card] [data-md-play]');
    if (!p) return;
    e.preventDefault();
    start(p.closest('[data-md-card]'), p.dataset.mdPlay);
  });

  /* Un MP4 ou l'audio qui démarre remet les vidéos à l'état d'imagette. */
  document.addEventListener('play', (e) => { if (e.target instanceof HTMLMediaElement && !(e.target.muted && e.target.loop)) reset(null); }, true);   /* les vidéos décoratives muettes en boucle (accueil) ne coupent pas le lecteur */
  document.addEventListener('mi:media-start', (e) => { if (e.detail !== 'youtube') reset(null); });
})();
